import { render, staticRenderFns } from "./Debtors.vue?vue&type=template&id=cbc4b314&scoped=true&"
import script from "./Debtors.vue?vue&type=script&lang=js&"
export * from "./Debtors.vue?vue&type=script&lang=js&"
import style0 from "./Debtors.vue?vue&type=style&index=0&id=cbc4b314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc4b314",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
